import { getSymbol } from "../../config/helper";

const BaseCurrency = () => {
  const symbol_code = getSymbol();
  return (
    <div
      className="base_currency"
      dangerouslySetInnerHTML={{
        __html: symbol_code,
      }}
    ></div>
  );
};

export default BaseCurrency;
